import Underline from './Underline';
import { UnderlineProps, UnderlineValueProps } from './types';

export type { UnderlineProps, UnderlineValueProps };
export default Underline;
